import { configureStore } from '@reduxjs/toolkit';
import { combineReducers, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { loadUser } from 'redux-oidc';
import entitiesReducer, { paginationReducer, uiStateReducer } from '_reducers';
import { efeApi } from '_services/edgeFileExport.service';
import { materialApi } from '_services/material.service.v2';
import session from './session';

const loggerMiddleware = createLogger();

const middleware = [];
if (process.env.NODE_ENV === 'development') {
  middleware.push(loggerMiddleware);
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = configureStore({
  reducer: combineReducers({
    entities: entitiesReducer,
    pagination: paginationReducer,
    ui: uiStateReducer,
    [efeApi.reducerPath]: efeApi.reducer,
    [materialApi.reducerPath]: materialApi.reducer,
  }),
  enhancers: composeEnhancers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
    .concat(efeApi.middleware)
    .concat(materialApi.middleware)
    .concat(middleware),
});

loadUser(store, session.userManager);

export default store;
